// packages/content/src/catalog/misc.ts (M1-T01) — stationery and wrapping are PaperEntry kinds kept in this file (§7.3)
import type { CatalogEntry } from '../schema/catalog';
export default [
  { id: 'paper.plain', kind: 'stationery', name: 'items.stationery', sell: 25, stack: 1, buy: 100, color: '#FFF6E0' },
  { id: 'wrap.plain', kind: 'wrapping', name: 'items.wrapping', sell: 30, stack: 1, buy: 120, color: '#EE7A5B' },
] as const satisfies readonly CatalogEntry[];
